export const ApiActions = {
    //Для переключателя методик нужно, что бы actions получения данных страниц вызывались по ключу страницы
    pageDataGetters: {
        login: 'student_interface_login_page'
    },
    setLangCode: 'student_interface_set_language_action',
    demoAccessRequest: 'student_interface_demo_access_request',
};